import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'sqep-dialog-close-button',
  imports: [MatIconModule, MatButtonModule],
  template: `
    <button
      tabindex="-1"
      mat-icon-button
      aria-label="close dialog"
      (click)="close.emit()"
    >
      <mat-icon [svgIcon]="'close'"></mat-icon>
    </button>
  `,
  styleUrls: ['./dialog-close-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogCloseButtonComponent {
  protected close = output<void>();
}
